'use client';
import { twJoin, twMerge } from 'tailwind-merge';
import Svg from '@/components/Svg';
import HeartOutlineIcon from '@/icons/HeartOutlineIcon';
import { FC } from 'react';
import { MouseEvent } from 'react';

type ClassNamesTypes = {
  btn?: string;
  svg?: string;
  fillColor?: string;
};

type HeartButtonPropTypes = {
  isWishlisted?: boolean;
  onClick?: any;
  classNames?: ClassNamesTypes;
};

const HeartIconButton: FC<HeartButtonPropTypes> = ({
  isWishlisted = false,
  onClick,
  classNames,
}) => {
  const clickFn = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    onClick(e);
  };
  return (
    <button
      onClick={clickFn}
      className={twMerge(`rounded-full bg-white p-2`, classNames?.btn)}>
      <Svg
        viewBox='0 0 16 16'
        className={twJoin(
          `h-4 w-4 cursor-pointer stroke-fig`,
          isWishlisted && classNames?.fillColor
            ? classNames?.fillColor
            : isWishlisted && !classNames?.fillColor
              ? 'fill-fig'
              : 'fill-none',
          classNames?.svg
        )}>
        <HeartOutlineIcon />
      </Svg>
    </button>
  );
};

export default HeartIconButton;
